export default __webpack_public_path__ + "static/media/founder2.a28f847f.png";